import { StackedImages } from "@/contents/sanityTypes"
import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import StackedContents from "@/ui/molecules/StackedContents"

export interface SanityStackedImagesProps {
  content: StackedImages
  className?: string
  alignment?: "left" | "right"
}

const SanityStackedImages = ({
  content,
  className,
  alignment = "left",
}: SanityStackedImagesProps) => {
  if (!content.images) {
    return <></>
  }
  return (
    <StackedContents
      items={content.images.map((image) => ({
        content: (
          <SanityImageField
            asset={image.image}
            responsive
            height="100%"
            objectFit="contain"
            style={{ minHeight: "30vh" }}
          />
        ),
        width: "70%",
        height: "70%",
      }))}
      angleDegrees={0}
      offsetYPercent={50}
      offsetXPercent={20}
      baseOffsetXPercent={alignment == "right" ? 22 : 0}
      className={className}
    />
  )
}

export default SanityStackedImages
